<template>
    <div>
        <select-bar
                class="p-p-3 p-d-flex p-jc-between"
                v-on:updateReportName="updateReportName"

        ></select-bar>
        <admin-list
                class="p-p-3"
                :selectedReportName="selectedReportName"
        ></admin-list>
    </div>
</template>

<script>
import adminList from '@/views/report/adminReport/adminList.vue'
import selectBar from '@/views/report/adminReport/adminSelectBar.vue'

export default {
    name: "admin-report",
    components: {
        adminList,
        selectBar
    },
    data() {
        return {
            selectedReportName: null,

        }
    },
    created() {
    },
    methods: {
            updateReportName(name) {
                this.selectedReportName = name
            },
    },
}
</script>

<style scoped>

</style>